import { render } from "./ProjectMessage.vue?vue&type=template&id=418dd0ba"
import script from "./ProjectMessage.vue?vue&type=script&lang=js"
export * from "./ProjectMessage.vue?vue&type=script&lang=js"

import "./ProjectMessage.vue?vue&type=style&index=0&id=418dd0ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__